import { Typography, TypographyVariant } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'

type ErrorViewProps = {
  errorMessage: string
  errorMessageSize?: TypographyVariant
}

export function ErrorView({ errorMessage, errorMessageSize = 'h5' }: ErrorViewProps) {
  const { t } = useTranslation()

  return (
    <Typography variant={errorMessageSize} color="primary">
      {`${errorMessage} ${t('typography.pleaseRefresh')}`}
    </Typography>
  )
}
